<template>
  <div>
    <b-row>
      <b-col
          md="2"
          sm="2"
          class="my-1"
      >
        <b-form-group
            class="mb-0"
        >
          <label class="d-inline-block text-sm-left mr-50">Anz. pro Seite</label>
          <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="w-50"
          />
        </b-form-group>
      </b-col>
      <b-col
          md="2"
          sm="2"
          class="my-1"
      >

        <b-input-group size="sm">
          <b-form-input
              id="filterInput"
              v-model="filter"
              type="search"
              placeholder="Voucher oder Suchbegriff"
          />
          <b-input-group-append>
            <b-button
                :disabled="!filter"
                @click="filter = ''"
            >
              Leeren
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>

      <b-col
          md="2"
          sm="2"
          class="my-1"
      >
        <b-form-group
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
                ref="fieldData"
                v-model="date.from"
                type="text"
                placeholder="Von Datum"
                autocomplete="off"
                show-decade-nav
                @keypress="EnterDate($event)"
            />
            <b-input-group-append>
              <b-form-datepicker
                  :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }"
                  button-only
                  :start-weekday="1"
                  locale="de-DE"
                  color="danger"
                  size="sm"
                  @context="onDateFromContext"
              />
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col
          md="2"
          sm="2"
          class="my-1"
      >
        <b-form-group
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
                ref="fieldData"
                v-model="date.to"
                type="text"
                placeholder="Bis Datum"
                autocomplete="off"
                show-decade-nav
                @keypress="EnterDate($event)"
            />
            <b-input-group-append>
              <b-form-datepicker
                  :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }"
                  button-only
                  :start-weekday="1"
                  locale="de-DE"
                  color="danger"
                  size="sm"
                  @context="onDateToContext"
              />
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col
          md="2"
          sm="2"
          class="my-1"
      >
        <b-button class="float-right btn-dark btn-sm btn-block" @click="Export()">
          <div
              v-show="loading.export"
              class="spinner-border spinner-border-sm mr-1"
              role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
          <span>als Excel exportieren</span>
        </b-button>
      </b-col>
      <b-col
          md="2"
          sm="2"
          class="my-1"
      >
        <b-button class="float-right btn-info btn-sm" @click="OpenModal()">
          Neue Einnahme
        </b-button>
      </b-col>

      <b-col
          md="12"
          xl="12"
      >
        <b-card-code>
          <b-badge
              :variant="sum > 0 ? 'success' : 'danger'"
              class="float-right mb-1 ml-1"
          >
            Kontostand: {{ FormatEuro(sum) }}
          </b-badge>

          <b-badge
              variant="warning"
              class="float-right mb-1 ml-1"
          >
            Einnahmen: {{ FormatEuro(revenue) }}
          </b-badge>

          <b-badge
              variant="success"
              class="float-right mb-1 ml-1"
          >
            Einnahmen-Bestätigt (EC): {{ FormatEuro(revenueConfirmedEc) }}
          </b-badge>
          <b-badge
              variant="success"
              class="float-right mb-1 ml-1"
          >
            Einnahmen-Bestätigt (Bar): {{ FormatEuro(revenueConfirmedBar) }}
          </b-badge>
          <b-table
              striped
              hover
              responsive
              :per-page="perPage"
              :fields="fields"
              :items="items"
          >
            <template #cell(Voucher)="data">
                <b-button @click="OpenVoucher(data.item.Vid)"
                          class="btn-block btn-sm btn-info"
                          variant="sm"
                >
                  {{ data.item.Vid }}
                </b-button>
            </template>
            <template #cell(Type)="data">
              {{ data.item.Type == 1 ? 'V' : '' }}
              {{ data.item.Type == 2 ? 'M' : '' }}
              {{ data.item.Type == 3 ? 'EC' : '' }}
            </template>
            <template #cell(Date)="data">
              {{ formatDate(data.item.Date) }}
            </template>
            <template #cell(Description1)="data">
              {{ data.item.Description1 }}
            </template>
            <template #cell(Description2)="data">
              {{ data.item.Description2 }}
              <b-badge
                  class="ml-1 mt-2 float-right" style="color: #e8e8e8; background: #007b8d; cursor: pointer;"
                  @click="$root.$emit('OpenNoteMenu', 'voucher'+data.item.Vid)"
              >
                Notiz
              </b-badge>
            </template>
            <template #cell(Cash)="data">
              <b-badge
                  style="width: 100%"
                  :variant="data.item.Cash >= 0 ? 'success':'danger'"
              >
                {{ FormatEuro(data.item.Cash) }}
              </b-badge>
            </template>
            <template #cell(Time)="data">
              {{ (data.item.TripFullDuration / 60 / 60).toFixed(2) }}
            </template>
            <template #cell(Action)="data">
              <b-button @click="ConfirmCash(data.item.Vid)"
                        v-show="data.item.Type == 1 && (data.item.SevDeskVoucherId == '' || data.item.SevDeskVoucherId == null)"
                        class="btn-block btn-sm btn-info"
                        variant="sm"
              >

                <div v-show="!data.item.loading">Bestätigen</div>
                <div v-show="data.item.loading">
                  <b-spinner
                      small
                      variant="light"
                      type="grow"
                  />

                </div>
              </b-button>
              <div v-if="data.item.Type == 3">SUP: {{ data.item.SumUpTransactionCode }}</div>
              <div v-else-if="data.item.Type == 1 && data.item.SevDeskVoucherId != null && data.item.SevDeskVoucherId != ''"><a target="_blank" :href="'https://my.sevdesk.de/ex/detail/id/'+data.item.SevDeskVoucherId">SD: {{ data.item.SevDeskVoucherId }}</a></div>
            </template>

            <template #cell(Action2)="data">
              <b-button @click="ConfirmBookCash(data.item.Vid)"
                        v-show="data.item.Type == 1 && !data.item.bookedInCheckout"
                        class="btn-block btn-sm btn-info"
                        variant="sm"
              >

                <div v-show="!data.item.loading">In Kasse Buchen</div>
                <div v-show="data.item.loading">
                  <b-spinner
                      small
                      variant="light"
                      type="grow"
                  />

                </div>
              </b-button>
              <div v-if="data.item.Type == 3">SUP: {{ data.item.SumUpTransactionCode }}</div>
              <div v-else-if="data.item.Type == 1 && (data.item.SevDeskVoucherId != '' && data.item.SevDeskVoucherId != null) && data.item.bookedInCheckout">

                <b-badge class="bg-success bg-darken-4">
                  <feather-icon
                      icon="BookOpenIcon"
                      size="15"
                  />
                  Ok</b-badge>
              </div>
            </template>
          </b-table>

        </b-card-code>
      </b-col>
      <b-col
          cols="12"
      >
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
        />
      </b-col>
    </b-row>

    <b-modal
        no-close-on-backdrop
        hide-footer
        id="modal-cash"
        centered
        size="lg"
        title="Neue Einnahme"
    >
      <b-row>
        <b-col
            md="8"
            xl="8"
        >
          <b-form-group
              label="Text"
          >

            <b-form-input
                size="sm"
                v-model="add.Text"
            />
          </b-form-group>
        </b-col>
        <b-col
            md="4"
            xl="4"
        >
          <b-form-group
              label="Betrag"
          >

            <euro-field ref="CashEuroFieldAmount"/>
          </b-form-group>
        </b-col>
      </b-row>

      <div>
        <b-button class="float-right" variant="success" @click="AddCash()">
          OK
        </b-button>
      </div>
      <template #modal-footer="{ ok, cancel}">
        <div></div>
      </template>
    </b-modal>
  </div>
</template>

<script>

import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BDropdown, BDropdownItem, VBTooltip, BSpinner, BFormDatepicker
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

import EuroField from '@/views/voucher2/EuroFild.vue'

export default {
  name: 'Call',
  components: {
    BFormDatepicker,
    BCardCode,
    BDropdown,
    BDropdownItem,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    EuroField,
    BSpinner,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      loading: {
        export: false
      },
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      add: {
        Text: '',
      },
      date: {
        from: '',
        to: ''
      },
      driver: 0,
      sum: 0,
      revenue: 0,
      revenueConfirmedEc: 0,
      revenueConfirmedBar: 0,
      bookedInCheckout: false,
      filter: null,
      filterTimeout: null,
      fields: [
        {
          key: 'Voucher',
          label: 'Buchung',
        },
        {
          key: 'Type',
          label: 'Typ',
        },
        {
          key: 'Date',
          label: 'Tag',
        },
        {
          key: 'Route',
          label: 'Strecke',
        },
        {
          key: 'Description1',
          label: 'Description1',
        },
        {
          key: 'Description2',
          label: 'Description2',
        },
        {
          key: 'Cash',
          label: 'Einnahmen',
        },
        {
          key: 'Time',
          label: 'Zeit',
        },
        {
          key: 'Action',
          label: 'Aktion',
        },
        {
          key: 'Action2',
          label: 'Aktion',
        },
      ],
      items: [],

    }
  },
  computed: {},
  mounted() {
    this.$nextTick(() => {
      document.title = 'Fahrerabrechnung'
    })
    this.$watch(
        () => this.currentPage,
        val => {
          this.Load()
        },
    )

    this.$watch(
        () => this.filter,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.Load()
          }, 550)
        },
    )

    this.Load()
  },

  methods: {

    EnterDate(event) {
      if (event.which == 13) {
        this.Load()
      }
    },
    onDateFromContext(ctx) {
      if (ctx.selectedDate) {
        // The date formatted in the locale, or the `label-no - date - selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
        this.date.from = ctx.activeFormatted
        this.Load()
      }
    },
    onDateToContext(ctx) {
      if (ctx.selectedDate) {
        // The date formatted in the locale, or the `label-no - date - selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
        this.date.to = ctx.activeFormatted
        this.value = ctx.activeFormatted
        this.Load()
      }
    },
    OpenModal() {
      this.add.Text = ''
      this.$nextTick(() =>

          this.$refs.CashEuroFieldAmount.Set(0)
      )
      this.$bvModal.show('modal-cash')
    },
    Export() {
      if(this.loading.export)
        return

      this.loading.export = true;
      let url = `/driver/invoice/export?driverId=${this.$route.params.driver}`
      if (this.filter && this.filter !== '') {
        url = url + `&filter=${this.filter}`
      }
      if (this.date.from != '') {
        const date = this.date.from.split('.')
        if (this.date.from.length == 8) {
          url += `&fromDate=${new Date('20' + date[2] + '-' + date[1] + '-' + date[0]).toDateString()}`
        }
      }
      if (this.date.to != '') {
        const date = this.date.to.split('.')
        if (this.date.to.length == 8) {
          url += `&toDate=${new Date('20' + date[2] + '-' + date[1] + '-' + date[0]).toDateString()}`
        }
      }
      this.$http.get(url, {responseType: 'blob'})
          .then(resp => {
            if (resp.data.success && !resp.data.success) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Fehler',
                  icon: 'CheckIcon',
                  text: "Es ist ein Fehler aufgetreten. (Error "+resp.data.errorCode+")",
                  variant: 'danger',
                },
              })
            } else {
              window.open(URL.createObjectURL(resp.data));
            }
            console.log(this.items)


            this.loading.export = false;
          })
          .catch(err => {
            this.loading.export = false;
            console.error(err)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fehler',
                icon: 'CheckIcon',
                text: err,
                variant: 'danger',
              },
            })
          })

    },
    AddCash() {
      if (this.$route.params.driver <= 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Fehler',
            icon: 'CheckIcon',
            text: 'Es ist ein Fehler aufgetreten.',
            variant: 'danger',
          },
        })
        return
      }
      if (this.$refs.CashEuroFieldAmount.fieldData == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Fehler',
            icon: 'CheckIcon',
            text: 'Es ist ein Fehler aufgetreten.',
            variant: 'danger',
          },
        })
        return
      }
      this.$http.post('/driver/add/cash', JSON.stringify({
        Driver: this.$route.params.driver,
        Cash: this.$refs.CashEuroFieldAmount.fieldData,
        Text: this.add.Text,
      }))
          .then(resp => {
            if (resp.data.success) {
              this.$bvModal.hide('modal-cash')
              this.Load()
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Info',
                  icon: 'CheckIcon',
                  text: 'Eintrag wurde erfasst.',
                  variant: 'success',
                },
              })
            }
          })
          .catch(err => {
            console.error(err)
          })

    },
    FormatEuro(euro) {
      return this.$options.filters.currency(euro)
    },
    OpenVoucher(vid) {
      this.$nextTick(() => {
        this.$router.push({
          name: 'VoucherMask',
          params: { id: vid }
        })
      })
    },
    ConfirmBookCash(vid) {
      Object.keys(this.items)
          .forEach(key => {
            if (this.items[key].Vid == vid) {
              if (!this.items[key].loading) {
                this.items[key].loading = true
                this.$http.get(`/voucher/book/cash/receipt?vid=${vid}`)
                    .then(resp => {
                      if (resp.data.success) {
                        Object.keys(this.items)
                            .forEach(key => {
                              if (this.items[key].Vid == vid) {
                                this.items[key].loading = false
                                this.items[key].SevDeskVoucherId = resp.data.SevDeskVoucherId
                              }
                            })

                        this.$toast({
                          component: ToastificationContent,
                          props: {
                            title: 'Ok',
                            icon: 'CheckIcon',
                            text: 'Bestätigt',
                            variant: 'success',
                          },
                        })
                      }

                    })
                    .catch(err => {
                      console.error(err)
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Fehler',
                          icon: 'CheckIcon',
                          text: err,
                          variant: 'danger',
                        },
                      })
                    })
              }
            }
          })
    },
    ConfirmCash(vid) {
      Object.keys(this.items)
          .forEach(key => {
            if (this.items[key].Vid == vid) {
              if (!this.items[key].loading) {
                this.items[key].loading = true
                this.$http.get(`/voucher/confirm/cash/receipt?vid=${vid}`)
                    .then(resp => {
                      if (resp.data.success) {
                        Object.keys(this.items)
                            .forEach(key => {
                              if (this.items[key].Vid == vid) {
                                this.items[key].loading = false
                                this.items[key].SevDeskVoucherId = resp.data.SevDeskVoucherId
                              }
                            })

                        this.$toast({
                          component: ToastificationContent,
                          props: {
                            title: 'Ok',
                            icon: 'CheckIcon',
                            text: 'Bestätigt',
                            variant: 'success',
                          },
                        })
                      }

                    })
                    .catch(err => {
                      console.error(err)
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Fehler',
                          icon: 'CheckIcon',
                          text: err,
                          variant: 'danger',
                        },
                      })
                    })
              }
            }
          })

    },
    clickCall(record, index) {

    },
    formatDate(date) {
      return `${new Date(date).toLocaleString('de-DE', {
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          },
      )}`
    },
    Load() {
      const currentDate = new Date()

      this.items = []
      const c1 = (this.currentPage - 1) * this.perPage
      let url = `/driver/invoice?driverId=${this.$route.params.driver}&from=${c1}&count=${this.perPage}`
      if (this.filter && this.filter !== '') {
        url = url + `&filter=${this.filter}`
      }
      if (this.date.from != '') {
        const date = this.date.from.split('.')
        if (this.date.from.length == 8) {
          url += `&fromDate=${new Date('20' + date[2] + '-' + date[1] + '-' + date[0]).toDateString()}`
        }
      } else {
        this.date.from = new Date(currentDate.setDate(currentDate.getDate() - 90))
            .toISOString()
            .split('T')[0]; // Format: JJJJ-MM-TT

        url += `&fromDate=${this.date.from}`
      }
      if (this.date.to != '') {
        const date = this.date.to.split('.')
        if (this.date.to.length == 8) {
          url += `&toDate=${new Date('20' + date[2] + '-' + date[1] + '-' + date[0]).toDateString()}`
        }
      }
      this.$http.get(url)
          .then(resp => {
            if (resp.data.success) {
              this.totalRows = resp.data.info.fullEntries
              this.sum = resp.data.Sum
              this.revenueConfirmedEc = resp.data.RevenueConfirmedEc
              this.revenueConfirmedBar = resp.data.RevenueConfirmedBar
              this.revenue= resp.data.Revenue
              resp.data.list.forEach(i => {
                if(i.SevDeskVoucherData != "" && i.SevDeskVoucherData && i.SevDeskVoucherData.CheckAccountTransaction.length > 0) {
                  i.bookedInCheckout = true;
                } else {
                  i.bookedInCheckout = false;
                }

                this.items.push(i)
              })
            }
            console.log(this.items)

          })
          .catch(err => {
            console.error(err)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fehler',
                icon: 'CheckIcon',
                text: err,
                variant: 'danger',
              },
            })
          })
    },
  },
}
</script>
